<template>
  <div class="radio">
    <div class="title">{{ info.title || "单选题" }}</div>
    <div
      class="radio-box"
      v-for="(item, index) in info.optionArr"
      :key="item.label"
    >
      <input
        type="radio"
        :name="item.label + info.title + 'radio'"
        :value="item.title"
        :id="item.label + info.title + 'radio'"
        v-model="info.content"
        :disabled="isStartGenerate"
      />
      <label :for="item.label + info.title + 'radio'">{{ item.title }}</label>
    </div>
  </div>
</template>

<script>
import message from "@/utils/message";
export default {
  name: "ContractRadio",
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    isStartGenerate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    getSubmitData() {
      const { title, isRequire, content, subjectType } = this.info;
      if (!isRequire) {
        return {
          questionnaire: 1,
          options: content,
          isRequired: isRequire ? 1 : 0,
          content: title,
          type: subjectType,
        };
      }
      if (!content) {
        message(`${title}未填写`);
        return false;
      } else {
        return {
          questionnaire: 1,
          options: content,
          isRequired: isRequire ? 1 : 0,
          content: title,
          type: subjectType,
        };
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.radio {
  margin-top: 30px;
}

.title {
  font-size: 16px
  font-weight: bold
}

.radio-box {
  margin: 10px 0 0;
  display: flex;
  align-items: center;

  label {
    font-size: 14px;
    font-weight: 400;
  }
}

input {
  margin: 0 10px 0 0;
}
</style>